// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import Home from "./Home";
import AboutUs from "./AboutUs";
import Destination from "./Destination";
import ContactUs from "./ContactUs";
import DestinationPackages from "./DestinationPackages";
import TripDetails from "./tripDetails/TripDetails";
import Hotel from "./Hotel";
import HotelDetails from "./HotelDetails";
import Cab from "./Cab";
import AITripDetailPage from "./AITripDetailPage";
import Career from "./Career";
import Blog from "./Blog";
import BlogDetails from "./BlogDetails";
import Activities from "./Activities";
import PaymentPolicy from "./PaymentPolicy";
import CancellationRefund from "./CancellationRefund";
import MyTrips from "./MyTrips";
import { FeedbackProvider, useFeedback } from "./context/FeedbackContext";
import FeedbackPopup from "./components/FeedbackPopup";
import FeedbackButton from "./components/FeedbackButton";

// Initialize Google Analytics with your Measurement ID
ReactGA.initialize("G-P4DDV1QPZX");

// Create a component to track page views
function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    // Send a pageview event whenever the route changes
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/destination" element={<Destination />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/DestinationPackages" element={<DestinationPackages />} />
      <Route path="/tripdetails" element={<TripDetails />} />
      <Route path="/hotel" element={<Hotel />} />
      <Route path="/hoteldetails" element={<HotelDetails />} />
      <Route path="/cab" element={<Cab />} />
      <Route path="/activities" element={<Activities />} />
      <Route path="/aitripdetail" element={<AITripDetailPage />} />
      <Route path="/career" element={<Career />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogDetails />} />
      <Route path="/payment-policy" element={<PaymentPolicy />} />
      <Route path="/cancellation-refund" element={<CancellationRefund />} />
      <Route path="/my-trips" element={<MyTrips />} />
    </Routes>
  );
}

// Global feedback popup component
function GlobalFeedbackPopup() {
  const { isOpen, triggerType, email, bookingId, closeFeedback } = useFeedback();

  return (
    <FeedbackPopup
      isOpen={isOpen}
      onClose={closeFeedback}
      triggerType={triggerType}
      email={email}
      bookingId={bookingId}
    />
  );
}

function App() {
  return (
    <FeedbackProvider>
      <Router>
        <AppRoutes />
        <GlobalFeedbackPopup />
        <FeedbackButton />
      </Router>
    </FeedbackProvider>
  );
}

export default App;
